// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeContestSetupGetBody = {
  poolId: string;
};

export type typeContestSetupGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    config: {
      startDate: string;
      roundGrouping: "day" | "week";
      weekStartDay?: number | null;
      roundLockTiming: "firstGame" | "lastGame";
      pickBasis: "moneyline" | "spread";
      spreadTiming?: "lockedEarly" | "live" | null;
      advanceCriterion: "winAll" | "winHalfOrMore";
      livesAllowed: number;
      requiredPicksPerRound: number;
      maxEntriesPerMember: number;
      teamReuseAllowed: boolean;
      teamReuseLockoutDays?: number | null;
      teamReuseMaxCount?: number | null;
      revivesAllowed: "unlimited" | "limited";
      revivesAllowedCount?: number | null;
      postponementPolicy: "makeUpNextRound" | "countAsLoss";
      tiePolicy: "tieIsWin" | "tieIsLoss";
      tiebreaker: "splitMedal" | "noWinner" | "commissionerPick";
      winPoints: number;
      lossPoints: number;
      skipsAllowed: boolean;
      skipsMaxPerContest?: number | null;
      endDate?: string | null;
      endDateMode?: "date" | "tbd" | null;
      pickSchedule?: {
        version: 1;
        requirements: {
          requirementId: string;
          startsOn: string;
          endsOn: string | null;
          timeZone: string;
          cadence: "day" | "week";
          weekStartDay: number | null;
          requiredPicks: number;
          revivedRequiredPicks: number | null;
          lockTiming: "firstGame" | "lastGame";
          teamReuseAllowed: boolean;
          inheritPreviousReuse: boolean;
          extendPreviousGames: boolean;
          postponementPolicy: "makeUpNextRound" | "countAsLoss";
        }[];
      } | null;
      spreadPolicy?: "automatic72h";
    } | null;
  };
};

export type typeContestSetupGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestSetupGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestSetupGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaContestSetupGetBody = {
  type: "object",
  properties: { poolId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["poolId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createContestSetupGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaContestSetupGetBody);
  }

  return async function postContestSetupGet(
    payload: typeContestSetupGetBody,
  ): Promise<typeContestSetupGetOutput200 | typeContestSetupGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postContestSetupGet" failed before calling the network. #da553ea32ada`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#da553ea32ada" },
        },
        data: null,
      } as typeContestSetupGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/contest/setup-get`,
      httpMethod: "POST",
      options,
    })) as typeContestSetupGetOutput200 | typeContestSetupGetOutput400;
  };
}
